import { useSearchParams } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import GeneralTab from './settings/GeneralTab';
import SnowflakeConnectionTab from './settings/SnowflakeConnectionTab';
import DbtBuildsTab from './settings/DbtBuildsTab';
import WhiteLabelTab from './settings/WhiteLabelTab';
import EllieTab from './settings/EllieTab';
import AnalyticsTab from './settings/AnalyticsTab';
import GitTab from './settings/GitTab';

const VALID_TABS = ['general', 'snowflake', 'dbt-builds', 'white-label', 'ellie', 'analytics', 'git'];

export default function SettingsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab') ?? '';
  const activeTab = VALID_TABS.includes(tabParam) ? tabParam : 'general';

  const setActiveTab = (tab: string) => {
    setSearchParams(tab === 'general' ? {} : { tab }, { replace: true });
  };

  return (
    <div className="p-8 h-full overflow-auto">
      <PageTitle title="Settings" className="mb-6" />

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList>
          <TabsTrigger value="general">General</TabsTrigger>
          <TabsTrigger value="snowflake">Snowflake Connection</TabsTrigger>
          <TabsTrigger value="dbt-builds">DBT Builds</TabsTrigger>
          <TabsTrigger value="white-label">White Label</TabsTrigger>
          <TabsTrigger value="ellie">Ellie</TabsTrigger>
          <TabsTrigger value="analytics">Analytics</TabsTrigger>
          <TabsTrigger value="git">Git</TabsTrigger>
        </TabsList>

        <TabsContent value="general" className="mt-6">
          <GeneralTab />
        </TabsContent>

        <TabsContent value="snowflake" className="mt-6">
          <SnowflakeConnectionTab />
        </TabsContent>

        <TabsContent value="dbt-builds" className="mt-6">
          <DbtBuildsTab />
        </TabsContent>

        <TabsContent value="white-label" className="mt-6">
          <WhiteLabelTab />
        </TabsContent>

        <TabsContent value="ellie" className="mt-6">
          <EllieTab />
        </TabsContent>

        <TabsContent value="analytics" className="mt-6">
          <AnalyticsTab />
        </TabsContent>

        <TabsContent value="git" className="mt-6">
          <GitTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
